import { InfoWindow } from '@vis.gl/react-google-maps';
import styled from 'styled-components';

import { COLORS } from 'theme';

export const InfoWindowContainer = styled(InfoWindow)`
  background-color: ${COLORS.black90};
  color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s1};
  font-family: Roboto;
  font-size: ${({ theme }) => theme.fontSize.body2};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.body2};
  max-width: 300px;
`;
